import { Component, Input, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import { BaseControlComponent } from '../base-control.component';

@Component({
  selector: 'boi-numeric-input',
  templateUrl: './numeric-input.component.html',
  styleUrls: ['./numeric-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: NumericInputComponent,
      multi: true
    }
  ]
})
export class NumericInputComponent extends BaseControlComponent {
  @Input() public autoCorrect?: boolean;
  @Input() public format?: string;
  @Input() public decimals?: number;
  @Input() public min?: number;
  @Input() public max?: number;
  @Input() public isCurrency: boolean;
  @Input() public maxLength?: number;
  @Input() public isTooltipLast = false;
  @ViewChild('numericInput') numericInput: NumericTextBoxComponent;

  public checkInputLength(event): void {
    if (event.target.value.length >= this.maxLength) {
      event.preventDefault();
    }
  }

  public getFormat(): string {
    let format = '#';
    if (this.format) {
      format = this.decimals ? `n${this.decimals}` : this.format;
    }

    return format;
  }

  public focus(): void {
    this.numericInput.focus();
  }
}
